export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {}
}



// WEBPACK FOOTER //
// ./src/store/priceLibrary.js